// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"_0-z","button":"a1-z","disabled":"b1-z","creditCard":"c1-z","wrapper":"d1-z"};